import { timeInterval } from 'd3-time';

const durationDay = 864e5;

const floor = (utcOffset: any) => (date: any) => {
  // setUTCMinutes and setUTCHours mutates the date
  date.setUTCMinutes(date.getUTCMinutes() + utcOffset);
  date.setUTCHours(0, -utcOffset, 0, 0);
  // and even though this is quite not nice ...
  // d3 scaleTime.nice doesn't use the return value but the mutated passed date
  return date;
};

const offset = (date: any, step: any) => date.setUTCDate(date.getUTCDate() + step);

const count = (start: any, end: any) => Math.abs(end - start) / durationDay;

// const field = utcOffset => date => addOffset(date, utcOffset).getUTCDate() - 1;

export const customDay = (utcOffset: any) => timeInterval(floor(utcOffset), offset, count);
